import { QuoteIneligibleErrorMessages } from '@constants/apiErrors';
import {
  BasketStatus,
  QuoteUnavailabilityReason,
} from '@generated/gql/graphql';

import { getAllBasketReasons, isEmptyBasketException } from './utils';

const hasAcceptableExceptions = (basketStatus: BasketStatus) => {
  const allReasons = getAllBasketReasons(basketStatus.unavailableStatuses);

  // None of these reasons should block filling out energy details
  const remainingReasons: QuoteUnavailabilityReason[] = allReasons.filter(
    ({ description }) =>
      ![
        QuoteIneligibleErrorMessages.simOnly,
        QuoteIneligibleErrorMessages.insuranceMustBeBundledWithAnotherService,
        QuoteIneligibleErrorMessages.cashbackCardMustBeBundledWithAnotherService,
        QuoteIneligibleErrorMessages.atLeastOneAccountHolderRequired,
      ].includes(description as QuoteIneligibleErrorMessages)
  );

  return remainingReasons.length === 0;
};

const energyDetailsValidator = (status: BasketStatus) => {
  if (
    status.isValidSelection ||
    isEmptyBasketException(status) ||
    hasAcceptableExceptions(status)
  ) {
    return true;
  }

  return false;
};

export { energyDetailsValidator };
